import { render, staticRenderFns } from "./EducationalGroupTransferAdd.vue?vue&type=template&id=374c3cf3&"
import script from "./EducationalGroupTransferAdd.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupTransferAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports